export const ERROR = {
    SET_ACTIVE : 'ERROR_SET_ACTIVE',
    SET_MESSAGE : 'ERROR_SET_MESSAGE'
};
